import { render, staticRenderFns } from "./PianoLink.vue?vue&type=template&id=718025b5&"
import script from "./PianoLink.vue?vue&type=script&lang=js&"
export * from "./PianoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports